import { useUserHasTableTotalsFeature } from 'src/hooks/useUserHasFeature';
import {
  ActionOutboxEntityType,
  GroupType,
  Listing,
  ListingGroup,
} from 'src/WebApiController';

import { ListingWithEvent } from '../ListingTable.types';

export const shouldHideInvisibleGroupData = (
  hasTableTotalsFeature: boolean,
  listing: Listing | null | undefined
) => {
  if (listing == null) {
    return false;
  }

  return (
    hasTableTotalsFeature &&
    listing?.isLtGrp &&
    (listing as ListingGroup).groupType === GroupType.Invisible
  );
};

export const useShouldHideInvisibleGroupData = (
  original: ListingWithEvent | null
) => {
  const hasTableTotalsFeature = useUserHasTableTotalsFeature(
    ActionOutboxEntityType.Listing
  );

  return shouldHideInvisibleGroupData(hasTableTotalsFeature, original?.listing);
};
